import { CALCULATOR_TYPES } from "constants/calculator";

import styles from "./InvestObjects.module.scss";

export const visibleFields = {
  aptArea: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  aptDinSize: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  aptPrice: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  aptRentPerMonth: [CALCULATOR_TYPES.BASIC, CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  aptFurniturePrice: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  aptDiscount: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  aptRentGrowth: [CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  aptLandShare: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  aptPriceGrowth: [CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],

  parkingDinSize: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  parkingPrice: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  parkingDiscount: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  parkingPriceGrowth: [CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  parkingLandShare: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  parkingRentPerMonth: [CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  parkingRentGrowth: [CALCULATOR_TYPES.LIMITED_PRO, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
};

export const disabledFields = {
  aptArea: [CALCULATOR_TYPES.LIMITED_PRO],
  aptDinSize: [CALCULATOR_TYPES.LIMITED_PRO],
  aptPrice: [CALCULATOR_TYPES.LIMITED_PRO],
  aptFurniturePrice: [CALCULATOR_TYPES.LIMITED_PRO],
  aptDiscount: [CALCULATOR_TYPES.LIMITED_PRO],
  aptLandShare: [CALCULATOR_TYPES.LIMITED_PRO],

  parkingDinSize: [CALCULATOR_TYPES.LIMITED_PRO],
  parkingPrice: [CALCULATOR_TYPES.LIMITED_PRO],
  parkingDiscount: [CALCULATOR_TYPES.LIMITED_PRO],
  parkingLandShare: [CALCULATOR_TYPES.LIMITED_PRO],
};

export const defaultFieldProps = {
  variant: "horizontal",
};

export const defaultFieldGroupProps = {
  label: "",
  variant: "horizontal",
  className: styles.fieldGroupControl,
  controlMultiple: true,
};
